import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { Calendar, Clock, Check, Users } from "lucide-react";

const MEAL_TYPE_BY_ID = {
    1: "Frühstück",
    2: "Mittagessen",
    3: "Abendessen",
    4: "Snack/Anderes",
};

const PlanDateSelectionDialog = ({
    show,
    onClose,
    onConfirm,
    recipeTitle,
    defaultServings = 2,
    initialDate = null,
    initialMealTimeId = 2,
    isEditMode = false
}) => {
    // Default to today/lunch if no initial values
    const [date, setDate] = useState(initialDate || new Date().toISOString().split('T')[0]);
    const [mealTimeId, setMealTimeId] = useState(initialMealTimeId);
    const [servings, setServings] = useState(defaultServings);

    // Reset/Initialize state when dialog opens or props change
    React.useEffect(() => {
        if (show) {
            setDate(initialDate || new Date().toISOString().split('T')[0]);
            setMealTimeId(initialMealTimeId);
            setServings(defaultServings);
        }
    }, [show, initialDate, initialMealTimeId, defaultServings]);

    const handleConfirm = () => {
        if (!date) return;
        onConfirm(date, Number(mealTimeId), servings);
        onClose();
    };

    return (
        <Modal show={show} onHide={onClose} centered size="sm">
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="fs-5 fw-bold">
                    {isEditMode ? "Eintrag bearbeiten" : "Rezept einplanen"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p className="text-muted small mb-4">
                    {isEditMode
                        ? <span>Ändere die Planung für <strong>{recipeTitle}</strong>:</span>
                        : <span>Wann möchtest du <strong>{recipeTitle}</strong> kochen?</span>
                    }

                </p>

                <div className="mb-3">
                    <label className="form-label small text-muted fw-bold d-flex align-items-center gap-2">
                        <Calendar size={14} /> Datum
                    </label>
                    <Form.Control
                        type="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        className="bg-light border-0"
                    />
                </div>

                <div className="mb-4">
                    <label className="form-label small text-muted fw-bold d-flex align-items-center gap-2">
                        <Clock size={14} /> Tageszeit
                    </label>
                    <Form.Select
                        value={mealTimeId}
                        onChange={(e) => setMealTimeId(e.target.value)}
                        className="bg-light border-0"
                    >
                        {Object.entries(MEAL_TYPE_BY_ID).map(([id, label]) => (
                            <option key={id} value={id}>{label}</option>
                        ))}
                    </Form.Select>
                </div>

                <div className="mb-4">
                    <label className="form-label small text-muted fw-bold d-flex align-items-center gap-2">
                        <Users size={14} /> Portionen
                    </label>
                    <div className="d-flex align-items-center bg-light rounded px-2 border">
                        <Button variant="link" className="text-dark p-0 px-2 fw-bold text-decoration-none" onClick={() => setServings(Math.max(1, servings - 1))}>-</Button>
                        <Form.Control
                            type="number"
                            value={servings}
                            onChange={(e) => setServings(Math.max(1, parseInt(e.target.value) || 1))}
                            className="bg-transparent border-0 text-center fw-bold shadow-none"
                            style={{ width: '60px' }}
                        />
                        <Button variant="link" className="text-dark p-0 px-2 fw-bold text-decoration-none" onClick={() => setServings(servings + 1)}>+</Button>
                    </div>
                </div>

                <div className="d-grid">
                    <Button variant="primary" onClick={handleConfirm} className="d-flex align-items-center justify-content-center gap-2">
                        <Check size={16} /> {isEditMode ? "Speichern" : "Einplanen"}
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default PlanDateSelectionDialog;
